import React from 'react';

import LayoutFooter from './SiteFooter';

// Shared landing-style footer. Hosted Console footer is not rendered.
const FooterComponent = ({ hideEmergency = false } = {}) => {
  return <LayoutFooter hideEmergency={hideEmergency} />;
};

export { LayoutFooter };
export default FooterComponent;
